@if (content) {
<div class="pos-relative overflow-hidden">
    <div class="bg-col-w pos-relative z-1">
        <div class="pos-relative overflow-hidden">
            <ng-container *ifSize="'SM'">
                <local-shell class="pe-none"></local-shell>
            </ng-container>
            <!-- top outlet -->
            <icms-outlet [components]=" content.topComponents"
                         [allow]=" ['seo-content']"
                         [name]=" 'Category page / top section'">
            </icms-outlet>
            <!-- breadcrumbs -->
            <div class="bg-col-51">
                <breadcrumbs class="wrap block no-scrollbar overflow-auto"></breadcrumbs>
            </div>
            <!-- name row -->
            @if (content.nameRowVisible) {
            <div class="wrap">
                <div class="c-4 c-12-set-s c-12-set-m">
                    <h1 class="m-t-12 m-t-5-s m-t-8-m"
                        sizeClass="SM: h3, XL: h2">{{ category.data.name | facetOverride : category.id : 'h1' }}</h1>
                    @if (category.data.description) {
                    <read-more class="col-12 m-t-4 block"
                               sizeClass="SM: p2, XL: p1"
                               [limit]="['80','130','120','100'][app.client.sizeId]"
                               [text]="category.data.description | facetOverride : category.id : 'description'"
                               readMore="Read more"
                               readLess="Read less">
                    </read-more>
                    }
                </div>
            </div>
            }
            <!-- middle outlet -->
            <icms-outlet [components]=" content.middleComponents"
                         [allow]=" ['seo-content']"
                         [name]=" 'Category page / middle section'">
            </icms-outlet>

        </div>
        <!-- listing -->
        <product-listing [context]="'category'"
                         [category]="category"
                         class="p-b-8 block wrap"
                         [listing]="categoryView.listing"></product-listing>
        <!-- Bottom components -->
        <ng-container *afterContentInit>
            <icms-outlet [components]=" content.bottomComponents"
                         [allow]=" ['seo-content']"
                         [name]=" 'Category page / bottom section'">
            </icms-outlet>
        </ng-container>
        <icms-outlet-block class="w-12"
                           name="Global Category Page Outlet"></icms-outlet-block>
    </div>
</div>
}
